import React from 'react';
import * as Scrivito from 'scrivito';
import SplitFlap from '../../components/SplitFlap';
import { pageLang, pick } from '../../lib/localize';

Scrivito.provideWidgetClass('WorldWideWidget', { attributes: {} });

const LABEL = {
  de: 'Länder weltweit im Netzwerk',
  en: 'Countries in our network',
};

const WorldWideWidget = Scrivito.connect(() => {
  const label = pick(LABEL, pageLang());

  return (
    <div className="tt-counter">
      <SplitFlap words={['184']} size="lg" />
      <span className="tt-counter__label">{label}</span>
    </div>
  );
});

Scrivito.provideComponent('WorldWideWidget', WorldWideWidget);

Scrivito.provideEditingConfig('WorldWideWidget', {
  title: 'World Wide Counter',
  properties: [],
});

export default WorldWideWidget;
